<button
  id="display"
  type="button"
  (click)="onOpenOverlay()"
  hisImage="CHECKBOX_TICK"
  class="transparent">
  {{ 'genericSearch.alreadySelectedItems' | hisUi }} ({{ selectedOptions().length }})
</button>

<p-dialog
  [(visible)]="displayOverlay"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
  header="{{ 'genericSearch.alreadySelectedItems' | hisUi }}">

  @if (displayOverlay()) {
    <p-table
      #searchResultSelectTable
      [value]="overlayRows()"
      [(selection)]="overlaySelection"
      dataKey="rowKey"
      [paginator]="true"
      [rows]="rowsPerPageOverlay"
      [rowHover]="true"
      [rowsPerPageOptions]="rowsPerPageOptionsOverlay"
      sortMode="multiple"
      [lazy]="false"
      [customSort]="true"
      (sortFunction)="handleSort($event)">
      
      <ng-template pTemplate="header">
        <tr>
          <th class="fitToContent">{{ 'genericSearch.rowselect' | hisUi }}</th>
          
          @for (column of columns(); track column.id) {
            @if (column.visible) {
              <th
                [pSortableColumnDisabled]="!column.sortable"
                [pSortableColumn]="column.sortPath"
                [id]="column.id">
                {{ column.label | hisUi }}
                @if (column.sortable) {
                  <p-sortIcon [field]="column.sortPath"></p-sortIcon>
                }
              </th>
            }
          }
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-row>
        <tr>
          <td class="multiSelectColumn">
            <p-tableCheckbox
              [value]="row"
              [ariaLabel]="getTableCheckboxTitle(row)"
              [title]="getTableCheckboxTitle(row)">
            </p-tableCheckbox>
          </td>
          
          @for (column of columns(); track column.id; let index = $index) {
            @if (column.visible) {
              <td>
                <his-search-result-table-cell
                  [column]="column"
                  [columnIndex]="index"
                  [row]="row"
                  [rowId]="row.getAt(idColumn())"
                  (beforeNavigateDefaultRoute)="onBeforeNavigateDefaultRoute()">
                </his-search-result-table-cell>
              </td>
            }
          }
        </tr>
      </ng-template>
  
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns().length + 1">
            {{ 'de.his.faces.tags.table.datascroller.noRowsFound' | hisUi }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }

  <ng-template pTemplate="footer">
    <button type="button" (click)="onUpdateTableSelectItems()" class="p-button-primary">
      {{ 'common.apply' | hisUi }}
    </button>
    <button type="button" (click)="onCancelOverlay()" class="p-button-secondary">
      {{ 'common.close' | hisUi }}
    </button>
  </ng-template>
</p-dialog>